export default "__VITE_ASSET__4XyitZQ2__"